// Import Swiper et les modules nécessaires
import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';

class BlockSliderMedias {
  constructor() {
    this._init();
  }

  _init() {
    // Enregistrer les modules utilisés

    new Swiper('.slider-medias__swiper', {
      modules: [Navigation, Pagination, EffectFade],
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      autoHeight: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        640: {
          autoHeight: false
        }
      }
    });
  }
}

export const blockSliderMedias = new BlockSliderMedias();
